export default __webpack_public_path__ + "static/media/info-icon.206b7c8e.svg";